var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { EntityStore, StoreConfig } from "@datorama/akita";
import * as i0 from "@angular/core";
var initialState = {
    page: {
        length: 0,
        pageIndex: 0,
        pageSize: 50
    }
};
var CourseStore = /** @class */ (function (_super) {
    __extends(CourseStore, _super);
    function CourseStore() {
        return _super.call(this, initialState) || this;
    }
    CourseStore.ngInjectableDef = i0.defineInjectable({ factory: function CourseStore_Factory() { return new CourseStore(); }, token: CourseStore, providedIn: "root" });
    CourseStore = __decorate([
        StoreConfig({ name: 'course-design' }),
        __metadata("design:paramtypes", [])
    ], CourseStore);
    return CourseStore;
}(EntityStore));
export { CourseStore };
